import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-54fc2fc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-dike" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "descriptions-group" }
const _hoisted_7 = { class: "descriptions-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "起点所在地:", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "descriptions-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "终点所在地:", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "descriptions-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "起点桩号:", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "descriptions-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "终点桩号:", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "descriptions-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "堤防类型:", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "descriptions-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "堤防跨界情况:", -1))
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "descriptions-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "河流名称:", -1))
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "descriptions-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "河流岸别:", -1))
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "descriptions-item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "堤防长度:", -1))
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "descriptions-item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "管理单位:", -1))
const _hoisted_36 = { class: "value" }
const _hoisted_37 = { class: "descriptions-item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "省级单位:", -1))
const _hoisted_39 = { class: "value" }
const _hoisted_40 = { class: "descriptions-item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "管理单位性质:", -1))
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "descriptions-item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "管理单位权属:", -1))
const _hoisted_45 = { class: "value" }
const _hoisted_46 = { class: "descriptions-item" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "管理单位负责人:", -1))
const _hoisted_48 = { class: "value" }
const _hoisted_49 = { class: "descriptions-item" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "责任人职务:", -1))
const _hoisted_51 = { class: "value" }
const _hoisted_52 = { class: "descriptions-item" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "联系电话:", -1))
const _hoisted_54 = { class: "value" }
const _hoisted_55 = { class: "descriptions-item" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "上级主管单位:", -1))
const _hoisted_57 = { class: "value" }

import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogDike',
  props: {
  data: Object,
},
  setup(__props) {

const props = __props
const { data } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data).dfmc || '-'), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(data).qdszd || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(data).zdszd || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(data).qdzh || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(data).zdzh || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(data).dflx || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(data).dfkjqk || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(data).hlmc || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(data).hlab || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(data).dfcd || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(data).gldw || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(data).sjdw || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(data).gldwxz || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(data).gldwqs || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(data).gldwfzr || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("span", _hoisted_51, _toDisplayString(_unref(data).zrrzw || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createElementVNode("span", _hoisted_54, _toDisplayString(_unref(data).lxdh || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_55, [
            _hoisted_56,
            _createElementVNode("span", _hoisted_57, _toDisplayString(_unref(data).sjzgdw || '-'), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})